




























import { getModule } from "vuex-module-decorators";
import { Component, Vue, Prop } from "vue-property-decorator";
import StatisticsConfig from "./data/StatisticsConfig";
import * as qlog from '@/data/QlogSchema';

import ConnectionConfigurator from "@/components/shared/ConnectionConfigurator.vue";
import ConnectionStore from "@/store/ConnectionStore";
import ConnectionGroup from "@/data/ConnectionGroup";
import Connection from "@/data/Connection";

@Component({
    components: {
        ConnectionConfigurator,
    },
})
export default class StatisticsConfigurator extends Vue {
    @Prop()
    public config!: StatisticsConfig;

    public store:ConnectionStore = getModule(ConnectionStore, this.$store);

    public onGroupSelected(group:ConnectionGroup) {
        console.log("StatisticsConfigurator:onGroupSelected : ", this.config, group);

        this.config.group = group;
    }

    public mounted(){
        if ( this.config.group === undefined && this.store.groups.length > 0 ){
            this.selectDefault();
        }
    }

    public updated(){
        if ( this.config.group === undefined && this.store.groups.length > 0 ){
            this.selectDefault();
        }
    }

    protected selectDefault(){
        console.log("selectDefault: adding new default connection configurator", this.store.groups);
        this.config.group = ( this.store.groups[0] );
    }

}

